/**
 * src/lib/severity.ts
 *
 * Severity → palette mapping, used by every component that renders an
 * alert. Keep in sync with tailwind.config.ts `colors.sev`.
 */

import type { AlertSeverity } from '@/types';

export const SEVERITY_RANK: Record<AlertSeverity, number> = {
  info: 0,
  warn: 1,
  error: 2,
  critical: 3,
};

interface SeverityStyle {
  /** Solid background — for badges. */
  bg: string;
  /** Foreground for text-on-bg. */
  fg: string;
  /** Border + soft tint — for cards. */
  ring: string;
  /** Pure colour name, useful for the dot indicator. */
  dot: string;
  label: string;
}

export const SEVERITY_STYLES: Record<AlertSeverity, SeverityStyle> = {
  info:     { bg: 'bg-sky-500/15',     fg: 'text-sky-300',     ring: 'ring-sky-500/30',     dot: 'bg-sev-info',     label: 'INFO'     },
  warn:     { bg: 'bg-yellow-500/15',  fg: 'text-yellow-300',  ring: 'ring-yellow-500/40',  dot: 'bg-sev-warn',     label: 'WARN'     },
  error:    { bg: 'bg-orange-500/20',  fg: 'text-orange-300',  ring: 'ring-orange-500/40',  dot: 'bg-sev-error',    label: 'ERROR'    },
  critical: { bg: 'bg-red-500/25',     fg: 'text-red-300',     ring: 'ring-red-500/50',     dot: 'bg-sev-critical', label: 'CRITICAL' },
};
